/**
 * Modal.tsx — wrapper rundt @carbon/react Modal
 *
 * Beholder vår eksisterende API (open, onClose, title, label, size, children)
 * men bruker Carbon Modal internt. Dette gir oss Carbon sine oppdateringer,
 * bugfixes og a11y-forbedringer uten å endre kallsetninger.
 *
 * Carbon-prosjektet bruker White theme (default) — ingen <Theme>-wrapper nødvendig.
 *
 * Bruk:
 *   <Modal open={isOpen} onClose={handleClose} title="Bekreft sletting" label="Advarsel">
 *     <p>Er du sikker?</p>
 *   </Modal>
 */

import { ReactNode } from 'react';
import { Modal as CarbonModal } from '@carbon/react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  /** Tittel (Carbon: modalHeading) */
  title: string;
  /** Carbon modal label — eyebrow-tekst over tittelen (valgfri) */
  label?: string;
  children: ReactNode;
  /** Størrelse: 'sm' (default), 'md', 'lg' */
  size?: 'sm' | 'md' | 'lg';
}

export default function Modal({
  open,
  onClose,
  title,
  label,
  children,
  size = 'sm',
}: ModalProps) {
  return (
    <CarbonModal
      open={open}
      onRequestClose={onClose}
      modalHeading={title}
      modalLabel={label}
      size={size}
      passiveModal // Vi rendrer egne knapper via children — ingen Carbon primary/secondary
    >
      {children}
    </CarbonModal>
  );
}
